<div *ngIf="!hide" class="container"><pre>{{ _data | json }}</pre></div>
